import React from "react";
import {useState} from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router';
import {AppPath} from "../../../Router/AppRouter.jsx";
import {useApi} from "../../../hooks/useApi.jsx";
import {GridContainerFlex} from "../../../components/layout/GridFlex/GridContainerFlex/GridContainerFlex.jsx";
import {GridItemFlex} from "../../../components/layout/GridFlex/GridItemFlex/GridItemFlex.jsx";
import {TextBoxInput} from "../../../components/formik/inputs/TextBoxInput.jsx";
import {SubmitButton} from "../../../components/formik/button/SubmitButton.jsx";
import {CancelButton} from "../../../components/formik/button/CancelButton.jsx";
import {Card} from "../../../components/composite/Card/Card.jsx";
import {Paragraph} from "../../../components/base/typography/Paragraph.jsx";

export const RequestPasswordResetForm = () => {
    const navigate = useNavigate();
    const {api, callApi} = useApi();
    const [resetRequestSent, setResetRequestSent] = useState(false);

    const  defaultMessage ="Check your email for a link to reset your password. If it doesn't appear within a few minutes, check your spam folder.";
    const goToLoginPage = () => {
        navigate(AppPath.login);
    }

    const handleSubmit = async (values) => {
        const res = await callApi({
            request: async () => {
                return await api.sendPasswordResetEmail(values.username);
            }
        });

        setResetRequestSent(true);
    };

    const validationSchema = Yup.object({
        username: Yup.string()
            .email('Use your email address')
            .required('Required')
    });

    return (
        <Card title={"Request Password Reset"}>
            <Formik
                initialValues={{ username: "" }}
                validationSchema={validationSchema}
                onSubmit={async (values, { setSubmitting }) => {
                    try {
                        setSubmitting(true)
                        await handleSubmit(values);
                    } catch (e) {
                        console.error(e);
                    } finally {
                        setSubmitting(false);
                    }
                }}
            >
                <Form>
                    <GridContainerFlex
                        flexDirection={"column"}
                        alignItems={"start"}
                        gap={"20px"}
                    >
                        <GridItemFlex xs={12}>
                            <TextBoxInput
                                name="username"
                                label="Email Address"
                                placeholder="you@example.com"
                            />
                        </GridItemFlex>
                        <GridItemFlex xs={12}>
                            <SubmitButton disabled={(resetRequestSent)}>
                                Send password reset email
                            </SubmitButton>
                        </GridItemFlex>
                        <GridItemFlex xs={12}>
                            <CancelButton onClick={goToLoginPage}>Go to login page</CancelButton>
                        </GridItemFlex>
                        {resetRequestSent &&
                            <GridItemFlex>
                                <Paragraph>
                                    {defaultMessage}
                                </Paragraph>
                            </GridItemFlex>
                        }
                    </GridContainerFlex>
                </Form>
            </Formik>
        </Card>
    );
};